/**
 * 고아 승격 시계 — `buildRows` 의 `now`(SPLITVIEW_ROWS_DESIGN D1-4.5).
 *
 * **1분 틱이다. 초당 갱신 금지.** 초당 갱신하면 `buildRows` 가 초당 돌아
 * 가상화기를 깨운다. 문턱이 3분(`ORPHAN_AFTER_MS`)이라 1분 해상도면
 * 충분하고, 오차는 항상 **늦는 쪽**이라 안전하다 — 승격이 늦는 것은
 * "아직 기다리는 중" 이지만, 이른 것은 정상 발화에 `문단 없음` 을 붙이는
 * 오탐이다(CLAUDE.md §1 규율 2).
 */

import { useEffect, useState } from 'react'

const TICK_MS = 60_000

export function useOrphanClock(): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), TICK_MS)
    return () => clearInterval(id)
  }, [])
  return now
}
